export const home_hero_image_section_props = promo => ({
    sx: {
        width: '100%',
        height: 'auto',
        flexFlow: 'column nowrap',
        margin: promo ? '5rem 0 0 0' : '0 0 0 0'
    }
})